var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#00C7AF","fillRule":"evenodd"},[React.createElement("path",{"d":"M6 12A6 6 0 116 0a6 6 0 010 12zm0-1.2a4.8 4.8 0 100-9.6 4.8 4.8 0 000 9.6z","key":0}),React.createElement("path",{"d":"M7.738 3.573a.573.573 0 11.956.63l-2.992 4.54a.573.573 0 01-.933.032l-1.651-2.16a.573.573 0 01.91-.695L5.19 7.44l2.548-3.867z","key":1})]));
}

Checkmark.displayName = "Checkmark";

Checkmark.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
